module.exports = __webpack_public_path__ + "img/wp-new-habit-card26.5576f2ee.png";